import clsx from "clsx";
import { useContext } from "react";
import { AnchorContext } from "./AnchorContext";

interface AnchorProps extends React.HTMLAttributes<HTMLDivElement> {
    id: string;
    active?: boolean;
    tag?: string;
    small?: boolean;
    static?: boolean;
    children: React.ReactNode;
}

const Anchor = ({ id, tag, small, static: isStatic, children, className, ...props }: AnchorProps) => {
    const active = useContext(AnchorContext);
    const isActive = isStatic ? false : active === id;

    const onClick = () => {
        const anchor = document.getElementById(id);

        if (anchor) {
            const top = anchor.getBoundingClientRect().top + window.scrollY - 175;
            window.scrollTo({ top, behavior: "smooth" });
        }
    };

    const sharedClasses = ["group flex rounded-lg items-center cursor-pointer gap-2 min-w-[168px]"];
    const smallClasses = ["min-h-[48px] text-base px-4 py-[11px] font-medium max-w-[168px]"];
    const largeClasses = ["min-h-[64px] text-xl p-4 font-bold"];
    const isActiveClasses = ["bg-primary-500 text-white"];
    const isStaticClasses = ["bg-[#f2f2f2] hover:bg-[#d2d2d3] text-zinc-950"];
    const defaultClasses = ["bg-primary-100 text-primary-500 hover:bg-primary-600 hover:text-white"];

    return (
        <div
            id={`anchor-${id}`}
            className={clsx([
                ...sharedClasses,
                ...(small ? smallClasses : largeClasses),
                ...(isActive ? isActiveClasses : []),
                ...(isStatic ? isStaticClasses : defaultClasses),
                className,
            ])}
            onClick={isStatic ? undefined : onClick}
            {...props}
        >
            {tag && (
                <span
                    className={clsx([
                        "flex rounded-full w-8 h-8 items-center justify-center",
                        isActive ? "bg-white text-primary-500" : "bg-primary-500 text-white",
                        "text-base font-bold",
                        "group-hover:bg-white group-hover:text-primary-500",
                    ])}
                >
                    {tag}
                </span>
            )}
            {children}
        </div>
    );
};

export default Anchor;
